




































































































































































































import EventSetupCard from "@/components/EventSetupCard.vue";
import PageBody from "@/components/PageBody.vue";
import PageHeader from "@/components/PageHeader.vue";
import { DomainHttp } from "@/mixins/http/domain";
import { NotificationHttp } from "@/mixins/http/notification";
// eslint-disable-next-line no-unused-vars
import { Domain } from "@/types/domain";
// eslint-disable-next-line no-unused-vars
import { NotificationGroup } from "@/types/notification";
import { toDomain, toNotificationGroup } from "@/utils";

// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from "axios";
import { Component, Mixins } from "vue-property-decorator";

@Component({
	components: {
		"page-header": PageHeader,
		"page-body": PageBody,
		"event-setup-card": EventSetupCard,
	},
})
export default class NotificationsSetup extends Mixins(DomainHttp, NotificationHttp) {
	public domains: Array<Domain> = [];
	private notificationSetup: NotificationGroup = {
		recipientEmailAddresses: [],
		domainIdsToBeNotifiedAbout: [],
		eventsToBeNotifiedAbout: [],
		groupName: "",
	};
	savingSetup: boolean = false;
	deleteLoading: boolean = false;

	showSuccessfulSaveSnackbar: boolean = false;
	mounted() {
		let notificationGroupId: string = this.$router.currentRoute.params["id"];
		if (notificationGroupId && notificationGroupId != "setup") {
			this.getGroupById(notificationGroupId).then(
				(response: AxiosResponse<any>) => (this.notificationSetup = toNotificationGroup(response))
			);
		}
		this.getDomains().then((response: AxiosResponse<any>) =>
			this.addApiResponseToDomains(response)
		);
	}

	updateEvents(eventName: string) {
		if (this.notificationSetup.eventsToBeNotifiedAbout.includes(eventName)) {
			let indexOfEvent: number = this.notificationSetup.eventsToBeNotifiedAbout.indexOf(eventName);

			this.notificationSetup.eventsToBeNotifiedAbout.splice(indexOfEvent, 1);
		} else {
			this.notificationSetup.eventsToBeNotifiedAbout.push(eventName);
		}
	}

	addMultipleToEvents(eventNames: Array<string>) {
		this.notificationSetup.eventsToBeNotifiedAbout = this.notificationSetup.eventsToBeNotifiedAbout.concat(
			eventNames
		);
		let eventsSet: Set<string> = new Set(this.notificationSetup.eventsToBeNotifiedAbout);
		this.notificationSetup.eventsToBeNotifiedAbout = Array.from(eventsSet);
	}

	private addApiResponseToDomains(response: AxiosResponse<any>): void {
		this.domains = [];
		response.data.forEach((apiDomain: any) => {
			let domain = toDomain(apiDomain);
			if (domain) {
				this.domains.push(domain);
			}
		});
	}

	attemptDeleteGroup(): void {
		this.deleteLoading = true;
		this.deleteGroup(this.notificationSetup)
			.then(() => {
				this.$router.push("/notifications");
			})
			.finally(() => {
				this.deleteLoading = false;
			});
	}

	get allSectionsHaveDataSet(): boolean {
		return (
			this.notificationSetup.recipientEmailAddresses.length > 0 &&
			this.notificationSetup.domainIdsToBeNotifiedAbout.length > 0 &&
			this.notificationSetup.eventsToBeNotifiedAbout.length > 0 &&
			this.notificationSetup.recipientEmailAddresses.length <= 10
		);
	}

	saveSetup() {
		this.savingSetup = true;
		setTimeout(() => {
			if (this.notificationSetup.id) {
				this.attemptUpdateGroup();
			} else {
				this.attemptCreateGroup();
			}
		}, 500);
	}

	attemptUpdateGroup() {
		this.updateGroup(this.notificationSetup)
			.then(() => {
				this.showSuccessfulSaveSnackbar = true;
			})
			.finally(() => (this.savingSetup = false));
	}

	attemptCreateGroup() {
		this.createGroup(this.notificationSetup)
			.then((response: AxiosResponse<any>) => {
				this.notificationSetup.id = response.data._id;
				this.$router.push("/notifications");
			})
			.finally(() => (this.savingSetup = false));
	}

	addMeToRecipients(): void {
		if (
			!this.notificationSetup.recipientEmailAddresses.includes(
				this.$store.getters["account/currentUser"].email
			)
		) {
			this.notificationSetup.recipientEmailAddresses.push(
				this.$store.getters["account/currentUser"].email
			);
		}
	}

	trackAllDomains(): void {
		this.notificationSetup.domainIdsToBeNotifiedAbout = this.domains.map(
			(domain) => domain.id
		) as Array<string>;
	}
}
